exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".share--mini .share__heading[_v-5a236532]{margin-bottom:.5rem}.share__heading[_v-5a236532]{font-family:Roboto,sans-serif;font-size:1.25rem;margin-bottom:1rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-5a236532&scoped=true!./~/sass-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=style&index=0!./~/eslint-loader!./src/v3-components/Share.vue
// module id = 288
// module chunks = 0